import { ListItemIcon, Menu, MenuItem } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import PersonIcon from "@material-ui/icons/Person";
import SettingsIcon from "@material-ui/icons/Settings";
import PeopleIcon from "@material-ui/icons/People";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import PasswordEditor from "@components/PasswordEditor";
import AuthenticationService from "@services/Authentication";
import { logout } from "@store/modules/auth";
import { joinClasses } from "@utils/materialUI";
import { familyPath } from "@utils/router";

const useStyles = makeStyles(() => ({
  bar: {
    position: "fixed",
    top: "0px",
    left: "0px",
    width: "100%",
    boxSizing: "border-box",
    zIndex: 997,
    "@media all and (min-width: 1024px)": {
      paddingLeft: "260px",
    },
  },
  barMain: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "64px",
    margin: "0px",
    padding: "0px 20px",
    boxSizing: "border-box",
    backgroundColor: "#ffffff",
    boxShadow: `0px 5px 5px -3px rgb(0 0 0 / 6%),\
      0px 8px 10px 1px rgb(0 0 0 / 4%),\
      0px 3px 14px 2px rgb(0 0 0 / 4%)`,
  },
  mobileMenuToggle: {
    "@media all and (min-width: 1024px)": {
      display: "none",
    },
  },
  iconButtonActive: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  divider: {
    marginBottom: "8px",
    marginTop: "8px",
  },
}));

function AdminHeaderBar(props) {
  const USERS_PATHNAME = "/usuarios";

  const userGroup = useSelector((state) => state.auth.group);

  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();

  const [activeSettingsButton, setActiveSettingsButton] = useState(false);
  const [settingsMenuAnchorEl, setSettingsMenuAnchorEl] = useState(null);
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState(null);
  const [userName, setUserName] = useState("");

  const [showPasswordEditor, setShowPasswordEditor] = useState(false);

  function handleToggleActiveMenu() {
    props.onToggleMenu(!props.activeMenu);
  }

  function handleMenuUsers() {
    history.push("/usuarios");
    setSettingsMenuAnchorEl(null);
  }

  function checkActiveButtons() {
    setActiveSettingsButton(familyPath(USERS_PATHNAME));
  }

  function openSettingsMenu(anchorElement) {
    setSettingsMenuAnchorEl(anchorElement);
  }

  function closeSettingsMenu() {
    setSettingsMenuAnchorEl(null);
  }

  function handleClickSettingsIcon(event) {
    openSettingsMenu(event.currentTarget);
  }

  function handleCloseSettingsMenu() {
    closeSettingsMenu();
  }

  function openUserMenu(anchorElement) {
    setUserMenuAnchorEl(anchorElement);
  }

  function closeUserMenu() {
    setUserMenuAnchorEl(null);
  }

  function executeLogout() {
    AuthenticationService.logout().then(() => {
      dispatch(logout());
      history.push("/login");
    });
  }

  function getUser() {
    AuthenticationService.currentAuthenticatedUser()
      .then((user) => {
        setUserName(user.username);
      })
      .catch((error) => {
        toast.error("Erro ao carregar dados de usuário!");
      });
  }

  function handleClickUserIcon(event) {
    openUserMenu(event.currentTarget);
  }

  function handleCloseUserMenu() {
    closeUserMenu();
  }

  function handleClickLogout() {
    executeLogout();
  }

  function handleClickChangePassword() {
    setShowPasswordEditor(true);
  }

  function handleClosePasswordEditor() {
    setShowPasswordEditor(false);
  }

  function handleCancelPasswordEditor() {
    setShowPasswordEditor(false);
  }

  function handleSuccessPasswordEditor() {
    setShowPasswordEditor(false);
  }

  useEffect(() => {
    checkActiveButtons();
    const unlistenHistory = history.listen(() => {
      checkActiveButtons();
    });
    return () => {
      unlistenHistory();
    };
  }, [history]);

  useEffect(() => {
    getUser();
  }, []);

  return (
    <div className={classes.bar}>
      <div className={classes.barMain}>
        <div>
          <IconButton
            onClick={handleToggleActiveMenu}
            aria-label="menu"
            className={classes.mobileMenuToggle}
          >
            {props.activeMenu && <CloseIcon />}
            {!props.activeMenu && <MenuIcon />}
          </IconButton>
        </div>
        <div>
          {userGroup === "admin" && (
            <IconButton
              onClick={handleClickSettingsIcon}
              className={joinClasses({
                [classes.iconButtonActive]: activeSettingsButton,
              })}
            >
              <SettingsIcon />
            </IconButton>
          )}
          <IconButton onClick={handleClickUserIcon}>
            <PersonIcon />
          </IconButton>

          <Menu
            anchorEl={settingsMenuAnchorEl}
            keepMounted
            open={Boolean(settingsMenuAnchorEl)}
            onClose={handleCloseSettingsMenu}
          >
            <MenuItem onClick={() => handleMenuUsers()}>
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <Typography>Gerenciar Usuários</Typography>
            </MenuItem>
          </Menu>

          {/* user menu */}
          <Menu
            anchorEl={userMenuAnchorEl}
            keepMounted
            open={Boolean(userMenuAnchorEl)}
            onClose={handleCloseUserMenu}
          >
            <MenuItem disabled>
              <ListItemIcon>
                <PersonIcon />
              </ListItemIcon>
              <Typography>{userName}</Typography>
            </MenuItem>
            <div className={classes.divider}>
              <Divider />
            </div>
            <MenuItem onClick={handleClickChangePassword}>
              <ListItemIcon>
                <VpnKeyIcon />
              </ListItemIcon>
              <Typography>Alterar Senha</Typography>
            </MenuItem>
            <MenuItem onClick={handleClickLogout}>
              <ListItemIcon>
                <ExitToAppIcon />
              </ListItemIcon>
              <Typography>Sair</Typography>
            </MenuItem>
          </Menu>
          {/* end user menu */}
        </div>

        <PasswordEditor
          show={showPasswordEditor}
          onClose={handleClosePasswordEditor}
          onCancel={handleCancelPasswordEditor}
          onSuccess={handleSuccessPasswordEditor}
        />
      </div>
    </div>
  );
}

AdminHeaderBar.propTypes = {
  activeMenu: PropTypes.bool,
  onToggleMenu: PropTypes.func,
};

AdminHeaderBar.defaultProps = {
  activeMenu: false,
  onToggleMenu: () => {},
};

export default AdminHeaderBar;
